import React from 'react'
import HeliportDaysHours from '../components/HeliportDaysHours'

export const HeliportDaysandHours = (props) => {
  return <HeliportDaysHours edit={false} />
}
export default HeliportDaysandHours
